import { render } from "./WrapWithSectionItem.vue?vue&type=template&id=89db4058&scoped=true"
import script from "./WrapWithSectionItem.vue?vue&type=script&lang=js"
export * from "./WrapWithSectionItem.vue?vue&type=script&lang=js"

import "./WrapWithSectionItem.vue?vue&type=style&index=0&id=89db4058&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89db4058"]])

export default __exports__